import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import { CBcPrivilegeTree, CBcPrivilegeGroup, CBcRoleInfo, } from '@/classes/BcClasses';
class BcDialog {
    constructor() {
        this.visible = false;
        this.formValid = false;
        this.loading = false;
        this.text = '';
        this.title = '';
        this.form = new CBcRoleInfo();
    }
}
class PrivilegeMethod {
}
let UserRole = class UserRole extends Vue {
    constructor() {
        super();
        this.list = [];
        this.listP = [];
        // prisGroup: CBcPrivilegeGroup = new CBcPrivilegeGroup() // for display
        this.prisGroupTree = []; // for display
        this.tabRole = null;
        this.tabRoleType = null;
        this.privilegesLoading = false;
        this.rolePrivilegesLoading = false;
        this.currentRole = new CBcRoleInfo();
        this.currentPrivilege = null;
        this.rolePrivilegeUpdateLoading = false;
        this.treeModel = [];
        this.treeActive = [];
        this.treeOpen = [];
        this.listOpMethod = [];
        this.snackbar = new CBcSnackbar();
        this.dialog = new BcDialog();
        this.copyDialog = {
            visible: false,
            formValid: false,
            loading: false,
            title: '复制角色',
            form: {
                name: '',
                text: '',
                description: ''
            }
        };
        this.pageLoading = false;
        this.pageRef = null;
        this.resizeObserver = null;
        const that = this;
    }
    get canSave() {
        const that = this;
        if (Number(that.tabRole) < 0)
            return false; // TODO:check it 2019-12-19
        let current = null;
        that.list.forEach((role, i) => {
            if (i === that.tabRole) {
                current = role;
            }
        });
        if (!current)
            return false;
        return !Vue.filter('arrayEqual')(that.treeModel.map((v) => v.id), (current.privileges || []).map((v) => v.id));
    }
    async mounted() {
        const that = this;
        await this.pageRefresh();
        this.$nextTick(() => {
            this.initPageLayoutObserver();
            requestAnimationFrame(() => {
                this.updatePageLayout();
            });
        });
        window.addEventListener('resize', this.handleResize);
    }
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        window.removeEventListener('resize', this.handleResize);
    }
    initPageLayoutObserver() {
        const pageEl = this.$refs.pageRef;
        const parent = pageEl?.parentElement;
        if (!parent || typeof ResizeObserver === 'undefined') {
            return;
        }
        this.resizeObserver = new ResizeObserver(() => {
            this.updatePageLayout();
        });
        this.resizeObserver.observe(parent);
    }
    handleResize() {
        this.$nextTick(() => {
            this.updatePageLayout();
        });
    }
    updatePageLayout() {
        const pageEl = this.$refs.pageRef;
        if (!pageEl) {
            return;
        }
        const parent = pageEl.parentElement;
        let height = parent?.clientHeight || 0;
        if (height <= 0) {
            const rect = pageEl.getBoundingClientRect();
            const footerHeight = /^xs$|^sm$/i.test(this.$vuetify.breakpoint.name) ? 56 : 36;
            height = window.innerHeight - rect.top - footerHeight;
        }
        pageEl.style.height = `${Math.max(height, 300)}px`;
    }
    onTreeActiveChanged(v, o) {
        const that = this;
        if (v === o && !v.length)
            return;
        that.currentPrivilege = v[0];
    }
    onTreeOpenChanged(v) {
        console.log('tree open:', v);
    }
    onLayoutContentChanged() {
        this.$nextTick(() => {
            this.updatePageLayout();
        });
    }
    async onTabRoleChanged(v, o) {
        const that = this;
        if (v === o && isNaN(that.tabRole) && isNaN(that.tabRoleType))
            return;
        that.currentPrivilege = null;
        // let pris:Array<CBcPrivilegeInfo> = []
        try {
            let current = that.list.find((_v, i) => i === that.tabRole);
            if (!current)
                return;
            that.rolePrivilegesLoading = true;
            const rdRolePris = (await that.axios.get(`/api/privileges/roles/${current.id}`)).data;
            if (!rdRolePris) {
                throw new Error('当前角色信息获取失败');
            }
            current = rdRolePris.result;
            // could be a function.
            that.list = that.list.map((vr, i) => {
                if (i === that.tabRole) {
                    vr = current; // (current.privileges || [])
                }
                return vr;
            });
            that.treeModel = current.privileges.map((rolePris) => new CBcPrivilegeTree(rolePris));
            that.rolePrivilegesLoading = false;
            // that.$nextTick(() => {
            //   that.treeModel = current.privileges.map((vi:any) => new CBcPrivilegeTree(vi))
            // })
        }
        catch (e) {
            that.rolePrivilegesLoading = false;
            console.log('load rolePrivileges error: ', e);
            that.snackbar.warn('当前角色信息获取失败');
        }
    }
    onDialogVisibleChanged(v, o) {
        const that = this;
        if (v === o)
            return;
        if (!v) {
            that.$refs.roleForm.reset();
        }
    }
    pageRefresh() {
        this.tabRole = null;
        this.getList();
        this.getListP();
    }
    getTypeName(type) {
        return /operation/i.test(type) ? '操作' : /element/i.test(type) ? '元素' : /menu/i.test(type) ? '菜单' : '文件';
    }
    getGroupName(type) {
        return /fun/i.test(type) ? '功能权限' : /data/i.test(type) ? '数据权限' : '未分组';
    }
    async getList() {
        const that = this;
        that.pageLoading = true;
        try {
            const res = (await that.axios.get('/api/privileges/roles', { params: {} })).data;
            that.list = res.result || [];
            that.pageLoading = false;
        }
        catch (e) {
            that.pageLoading = false;
            console.log('error to load role:', e);
            that.snackbar.error('数据加载失败');
        }
    }
    async getListP() {
        const that = this;
        that.privilegesLoading = true;
        try {
            const res = (await that.axios.get('/api/privileges', { params: {} })).data;
            that.listP = res.result || [];
            that.prisGroup = new CBcPrivilegeGroup(that.listP);
            that.prisGroupTree = [
                new CBcPrivilegeTree({ id: 'root0', name: '功能权限', children: that.prisGroup.funs }),
                new CBcPrivilegeTree({ id: 'root1', name: '数据权限', children: that.prisGroup.datas })
            ];
            that.privilegesLoading = false;
        }
        catch (e) {
            that.privilegesLoading = false;
            console.log('error to load privileges:', e);
            that.snackbar.error('数据加载失败');
        }
    }
    createNew() {
        const that = this;
        that.dialog.title = '新增角色';
        that.dialog.visible = true;
    }
    editItem() {
        const that = this;
        console.log('editItem');
    }
    deleteItem() {
        const that = this;
        console.log('deleteItem');
    }
    async save() {
        const that = this;
        if (!that.$refs.roleForm.validate()) {
            that.snackbar.warn('请填写必要字段后重试.');
            return;
        }
        that.dialog.loading = true;
        try {
            const res = await that.axios.post('/api/roles', that.dialog.form);
            that.dialog.loading = false;
            that.dialog.visible = false;
            that.dialog.form = new CBcRoleInfo();
            that.getList();
            that.snackbar.success('角色新增成功:');
        }
        catch (e) {
            that.dialog.loading = false;
            console.log('save role error:', e);
            that.snackbar.error('权限新增失败:' + (e && (e.result || e.info || e.error)));
        }
    }
    async updateRolePrivileges() {
        const that = this;
        let current = null;
        that.list.forEach((role, i) => {
            if (i === that.tabRole) {
                current = role;
            }
        });
        if (!(current && current.id)) {
            that.snackbar.error('当前角色无效，权限更新失败');
            return false;
        }
        that.rolePrivilegeUpdateLoading = true;
        try {
            const res = await that.axios.post('/api/privileges/roles', { roleId: current.id, privileges: that.treeModel.map((v) => v.id) });
            that.rolePrivilegeUpdateLoading = false;
            that.snackbar.success('角色权限分配成功:');
        }
        catch (e) {
            that.rolePrivilegeUpdateLoading = false;
            console.log('update role privileges error:', e);
            that.snackbar.error('角色权限分配失败:' + (e && (e.result || e.info || e.error)));
        }
    }
    /**
     * 删除角色信息
     */
    async deleteRole() {
        const that = this;
        let current = null;
        that.list.forEach((role, i) => {
            if (i === that.tabRole) {
                current = role;
            }
        });
        if (!(current && current.id)) {
            that.snackbar.error('当前角色无效，权限更新失败');
            return false;
        }
        try {
            const res = await that.axios.delete('/api/roles/' + current.id, {});
            that.snackbar.success('角色删除成功:');
            that.getList();
        }
        catch (e) {
            console.log('delete role error:', e);
            that.snackbar.error('角色删除失败:' + (e && (e.result || e.info || e.error)));
        }
    }
    async copyRole() {
        const that = this;
        let current = null;
        that.list.forEach((role, i) => {
            if (i === that.tabRole) {
                current = role;
            }
        });
        console.log('current:', current);
        that.copyDialog.title = `复制角色(${current.name})`;
        that.copyDialog.form = {
            name: `${current.name}_Copy`,
            text: `${current.text}_Copy`,
            description: current.description,
            copyRoleId: current.id
        };
        that.copyDialog.visible = true;
    }
    async saveCopyRole() {
        const that = this;
        console.log('saveCopyRole', that.copyDialog.form);
        if (!that.$refs.copyRoleForm.validate()) {
            that.snackbar.warn('请填写必要字段后重试.');
            return;
        }
        that.copyDialog.loading = true;
        try {
            const res = await that.axios.post('/api/roles/copy', that.copyDialog.form);
            that.copyDialog.loading = false;
            that.copyDialog.visible = false;
            that.copyDialog.form = new CBcRoleInfo();
            that.getList();
            that.snackbar.success('角色复制成功:');
        }
        catch (e) {
            that.copyDialog.loading = false;
            console.log('save copy role error:', e);
            that.snackbar.error('角色复制失败:' + (e && (e.result || e.info || e.error)));
        }
    }
};
__decorate([
    Watch('treeActive')
], UserRole.prototype, "onTreeActiveChanged", null);
__decorate([
    Watch('treeOpen')
], UserRole.prototype, "onTreeOpenChanged", null);
__decorate([
    Watch('pageLoading'),
    Watch('privilegesLoading'),
    Watch('rolePrivilegesLoading')
], UserRole.prototype, "onLayoutContentChanged", null);
__decorate([
    Watch('tabRole')
], UserRole.prototype, "onTabRoleChanged", null);
__decorate([
    Watch('dialog.visible')
], UserRole.prototype, "onDialogVisibleChanged", null);
UserRole = __decorate([
    Component({
        name: 'Role',
        components: {
            BcSnackbar,
        }
    })
], UserRole);
export default UserRole;
;
